const upAnim = (delay) => {
    return {
        opacity:[1,0],
        y:[0,-70],
        transition:{duration: 2,  delay: delay, type: 'spring', stiffness: '200', damping: '40' }
    }
}

export default upAnim;
